/**
 * Pending permission prompts. The WS dispatcher pushes new
 * `agent.permission.request` envelopes here; the modal component renders the
 * head of the queue and dequeues it once the user decides.
 */

import { create } from "zustand";
import type { AgentPermissionRequest } from "@paperclip-cloud/shared";

interface PermissionState {
  pending: AgentPermissionRequest[];
  enqueue: (req: AgentPermissionRequest) => void;
  resolve: (requestId: string) => void;
  clear: () => void;
}

export const usePermissionStore = create<PermissionState>((set) => ({
  pending: [],

  enqueue: (req) =>
    set((s) => {
      // Defensive: don't enqueue duplicates if the hub re-sends.
      if (s.pending.some((p) => p.request_id === req.request_id)) return s;
      return { pending: [...s.pending, req] };
    }),

  resolve: (requestId) =>
    set((s) => ({
      pending: s.pending.filter((p) => p.request_id !== requestId),
    })),

  clear: () => set({ pending: [] }),
}));
